import { render, staticRenderFns } from "./HealthCheck35PsaThyroidLiver.vue?vue&type=template&id=49ab4e72&scoped=true&"
import script from "./HealthCheck35PsaThyroidLiver.vue?vue&type=script&lang=js&"
export * from "./HealthCheck35PsaThyroidLiver.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck35PsaThyroidLiver.vue?vue&type=style&index=0&id=49ab4e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab4e72",
  null
  
)

export default component.exports